import { render } from "./TemplateSection.vue?vue&type=template&id=00a18a79&scoped=true"
import script from "./TemplateSection.vue?vue&type=script&lang=js"
export * from "./TemplateSection.vue?vue&type=script&lang=js"

import "./TemplateSection.vue?vue&type=style&index=0&id=00a18a79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a18a79"]])

export default __exports__